export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "loading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cargando"])}
        }
      },
      "en": {
        "labels": {
          "loading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Loading"])}
        }
      }
    }
  })
}